import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAll } from "./rhheaderAPI";

const initialState = {
  value: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
};

export const fetchAll = createAsyncThunk("rhheader/fetchAll", async (payload) => {
  const response = await getAll(payload);
  return response.data;
});

export const rhheaderSlice = createSlice({
  name: "rhheader",
  initialState,
  reducers: { resetData: (state) => initialState },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAll.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      });
  },
});

export const { resetData } = rhheaderSlice.actions;

export const selectData = (state) => state.rhheader.value;
export const selectLoading = (state) => state.rhheader.loading;
export const selectError = (state) => state.rhheader.error;
export const selectPageNo = (state) => state.rhheader.pageNo;
export const selectPageSize = (state) => state.rhheader.pageSize;
export const selectTotalRecord = (state) => state.rhheader.totalRecord;

export default rhheaderSlice.reducer;
